import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import useStyles from "./styles";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function IdleTimerPoper({ handleOpen, handleClose, logout, ...props }) {

  const [count, setCount] = useState(0);
  const [logoutFunction, setLogoutFunction] = useState(true);
  const classes = useStyles();


  const stopLogout = () => {
    setLogoutFunction(false)
    handleClose()
  }


  useEffect(() => {
    let timeoutId;

    if (logoutFunction) {
      timeoutId = setTimeout(() => {
        logout()
      }, 60000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };


  }, [logoutFunction])

  return (
    <div>
      <Dialog
        open={handleOpen}
        classes={{ paper: classes.dialogPaper }}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div className={classes.content}>
          <h3>
            Your session is about to expire!
          </h3>
        </div>

        <div className={classes.footer}>
          <div className={classes.footerRight}>
            <Button className={classes.changeBtn} onClick={logout}>Logout</Button>
            <Button onClick={() => stopLogout()} className={classes.backBtn}>Stay Logged In</Button>
          </div>
        </div>

      </Dialog>
    </div>
  );
}